var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 67,
    viewBox: "0 0 90 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.94682 63.7806L4.37568 65.4774L82.7487 65.5488V38.0075L83.3739 34.8997L84.1419 33.1851L83.1953 31.7562L81.0162 31.4883L80.6412 28.3984L82.3915 24.2369L83.8204 23.4867L84.8742 21.5935L84.6062 20.0038L86.1423 18.057L86.9282 14.4313L89 11.0377L88.0177 8.4658L86.8031 8.10858L85.535 7.44773L83.8382 4.64359H61.9052L60.1906 5.66165L55.0288 6.01887L53.7071 7.21554L52.2961 7.07266L45.7769 9.53744L43.6694 8.62654L40.6866 10.2876L38.9005 9.9661L37.4717 10.6805L35.7035 9.466H30.5774L27.2553 11.3771L24.4333 11.2164L21.0041 10.5198L19.8074 6.89405L19.4502 4.59001L18.3428 2.80394L16.5031 1.76801L15.1814 2.5896L13.8419 2.48244L12.0201 1L10.4841 1.85732L9.25167 1.66085L8.41222 2.26811L7.84067 1.85732L7.07266 1.53584V2.80394L7.5549 4.28641L6.76903 5.57239L7.17983 8.35864L8.10858 8.94805L7.5549 9.51962L7.42988 11.3593L8.64441 12.7346L7.07266 12.3952L6.76903 18.9501L6.644 21.6113L6.07246 21.8078L5.84027 24.7906L6.644 26.3266L5.94743 27.1124L4.71504 39.9365L3.60767 43.4372L4.25066 44.241L2.57175 45.5984L1.19647 51.7067L1 53.0463L2.3217 55.6183L2.0895 57.4758L2.57175 59.0833L2.0895 59.6369L2.57175 60.8872L2.94682 63.7806Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOr);
export default __webpack_public_path__ + "static/media/OR.3a98e89389c6174b96030099694e09fc.svg";
export { ForwardRef as ReactComponent };